export default __webpack_public_path__ + "b1ea947758c520ece38c547079e7c39c.png";